module.exports = __webpack_public_path__ + "img/UCL360_banner4_m.c9e0b697.png";